import { RootState } from '@/store';
import { getCleanPathname } from '@ianesthesie-kit/config';

const isOnQuestionnairePage = () =>
  typeof location !== 'undefined' &&
  getCleanPathname(location.pathname).startsWith('/questionnaire') &&
  !location.pathname.includes('overview');

const isOnConsentPage = () =>
  typeof location !== 'undefined' &&
  getCleanPathname(location.pathname).startsWith('/consent');

export const dialogsAllowedOnPage = () =>
  !isOnQuestionnairePage() && !isOnConsentPage();

export const selectIsAnyDialogOpen = (state: RootState) => state.ui.dialog.open;
